/* Claude modifications -5r: desktop product gallery = one large photo + a row of thumbnails.
   All photos stay in the page (the theme's own list); on desktop CSS shows only the active one
   (.fg-active) and this script builds the thumbnail buttons from that list. Respects "Hide other
   variants' media": photos of other colours are left out, and when the colour changes the theme
   moves the new colour's photo to the front, so the row is rebuilt and that photo becomes active.
   Phones and tablets keep the theme's slider (the CSS only applies from 990px). */
(function () {
  function init(wrapper) {
    var list = wrapper.querySelector('.product__media-list');
    var thumbs = wrapper.querySelector('[data-fg-thumbs]');
    if (!list || !thumbs) return;

    function photos() {
      return Array.prototype.filter.call(list.children, function (item) {
        // Same rule as the theme: other colours' photos are hidden, except the one shown first
        return !item.classList.contains('product__media-item--variant') || item === list.firstElementChild;
      });
    }

    function setActive(item) {
      Array.prototype.forEach.call(list.children, function (li) {
        li.classList.toggle('fg-active', li === item);
      });
      Array.prototype.forEach.call(thumbs.children, function (button) {
        var on = button.getAttribute('data-media-id') === item.getAttribute('data-media-id');
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function build() {
      var items = photos();
      thumbs.innerHTML = '';
      items.forEach(function (item, index) {
        var img = item.querySelector('img');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'fg-thumbs__item';
        button.setAttribute('data-media-id', item.getAttribute('data-media-id'));
        button.setAttribute('aria-label', 'Show photo ' + (index + 1) + ' of ' + items.length);
        if (img) {
          var thumb = document.createElement('img');
          thumb.src = img.currentSrc || img.src;
          thumb.alt = '';
          thumb.loading = 'lazy';
          button.appendChild(thumb);
        }
        button.addEventListener('click', function () { setActive(item); });
        thumbs.appendChild(button);
      });
      if (items.length) setActive(items[0]);
    }

    build();
    // Only switch to the one-photo layout once the thumbnails exist (without the script the theme's grid stays)
    wrapper.classList.add('fg-ready');
    // The theme reorders the list when the shopper picks another colour
    new MutationObserver(build).observe(list, { childList: true });
  }

  function start() {
    document.querySelectorAll('.fg-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
